var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerticalArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 32,
    viewBox: "0 0 10 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#01AE8F",
    d: "M31 5.008c-.27 0-30.716-.006-31-.016",
    transform: "translate(-32 -662) translate(0 48) translate(12 215) translate(20 301) translate(0 98) rotate(90 5 5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01AE8F",
    d: "M28.512 1.222l3.426 8.4c.209.512-.037 1.095-.548 1.304-.12.049-.248.074-.378.074h-7c-.552 0-1-.448-1-1 0-.135.027-.268.08-.392l3.574-8.4C26.882.7 27.47.465 27.978.68c.243.103.435.298.534.542z",
    transform: "translate(-32 -662) translate(0 48) translate(12 215) translate(20 301) translate(0 98) rotate(90 5 5) rotate(90 27.5 5)"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalArrow);
export default __webpack_public_path__ + "static/media/vertical-arrow.a38e81f63b12bd6b1d09671b8c8d5175.svg";
export { ForwardRef as ReactComponent };